import React from 'react';

import { Route, Routes } from 'react-router-dom';
import Home from './containers/HomePage/Home';
import Details from './containers/HomePage/Deatails';
import AdminDashboard from './containers/AdminDashboard/AdminDashboard';

const RoutesApp = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/project-detail/:id/:cc/:sessionID" element={<Details />} />
      <Route path="/admin-ms" element={<AdminDashboard />} />
    </Routes>
  );
};

export default RoutesApp;
